import { dexMutation } from '@/helpers/graphql';
import {
  DexCreateReply,
  RepliesByQuestionIdListType,
  SolutionsByQuestionId,
} from '@/models/undergrad/services/dex.services.model';
import { createReplyMutation } from '@/store/queries/dexQueries';

interface DexReplyType {
  reply: RepliesByQuestionIdListType;
  solutions: SolutionsByQuestionId[];
}

export class DexReplyService {
  static async createReply(payload: DexCreateReply): Promise<DexReplyType> {
    const { questionId, userId, alternativeId, answer } = payload;

    const {
      data: {
        createReply: { reply },
      },
    } = await dexMutation(createReplyMutation, {
      questionId,
      userId,
      assertionId: alternativeId,
      answer,
    });

    const {
      questionByQuestionId: { solutionsByQuestionIdList },
    } = reply;

    return {
      reply: { id: reply.id, alternativeId: reply.alternativeId },
      solutions: solutionsByQuestionIdList,
    };
  }
}
